<!-- タブメニューアイテム。 タイトルと未読バッジ表示をする -->
<script setup lang="ts">
  import { type ICON_TYPE } from "~/components/Atoms/MenuIcon.vue";

  // TODO: 別ファイルからinterfaceを読み込んでPropsに設定しようとするとstorybookがうまく機能しない
  // import { ITabMenuItemInfo } from '~/interfaces/ITabMenuItemInfo'
  // interface Props extends ITabMenuItemInfo {
  // }
  interface Props {
    value: string;
    title: string;
    count?: number;
    icon?: ICON_TYPE;
    vertical?: boolean;
  }
  const props = withDefaults(defineProps<Props>(), {
    count: 0,
    icon: undefined,
    vertical: false,
  });

  const tabSliderWidth = computed<string>(() => {
    return props.title.length * 16 + (props.icon ? 24 : 0) + "px";
  });

  // レスポンシブ対応
  const isSp = isSpDisplayRef();
  const menuFontSize = computed(() => (isSp.value ? "14px" : "16px"));
</script>

<template>
  <v-tab
    v-ripple="{ class: `text-monochrome-04` }"
    :value="value"
    :class="{ tab_vertical: vertical, rounded: true, 'font-weight-bold': true }"
    :width="vertical ? 60 : null"
    :max-width="vertical ? 60 : null"
    :min-width="vertical ? 60 : null"
    color="monochrome-04"
    variant="flat"
  >
    <template v-if="vertical">
      <template v-if="count && count > 0">
        <v-badge color="red" dot :offset-x="-7" :offset-y="-7">
          <div>
            <div v-if="icon" class="tab_vertical_icon">
              <AtomsSvgIcon :width="22" :img-path="`assets/images/icon/menu/${icon}.svg`" class="tab_icon" />
            </div>
          </div>
        </v-badge>
        <small class="tab_vertical_title">{{ title }}</small>
      </template>
      <template v-else>
        <div v-if="icon" class="tab_vertical_icon">
          <AtomsSvgIcon :width="22" :img-path="`assets/images/icon/menu/${icon}.svg`" class="tab_icon" />
        </div>
        <small class="tab_vertical_title">{{ title }}</small>
      </template>
    </template>
    <template v-else>
      <AtomsMenuIcon v-if="icon" :icon="icon" :width="16" :height="16" class="my-2 mr-2 tab_icon" />
      <v-badge v-if="count && count > 0" class="tab-menu-title" color="red" dot :offset-x="-7" :offset-y="-7">
        {{ title }}
      </v-badge>
      <span v-else class="tab-menu-title"> {{ title }} </span>
    </template>
  </v-tab>
</template>

<style lang="scss">
  /* タブ選択時の下線の横幅を変更する */
  .v-tab__slider {
    bottom: 10px;
    left: initial;
    height: 1px;
    width: v-bind(tabSliderWidth);
  }
  .tab_vertical {
    text-align: center;
    position: relative;
    height: 48px !important;
    .v-tab__slider {
      display: none;
    }
    .tab_vertical_icon {
      display: block;
      margin: -8px auto 0;
    }
    .tab_vertical_title {
      display: block;
      font-size: 8px;
      margin: 0 auto;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 5px;
    }
  }
  .tab_icon {
    .icon-img {
      transform: scale(0.5) translate(-60%, -50%);
    }
  }
  .tab-menu-title {
    font-size: v-bind(menuFontSize);
    font-weight: 700;
    line-height: 1.8em;
    letter-spacing: 0.06em;
  }
</style>
